import { ReceiptIndianRupee, FileSpreadsheet, FileBarChart2, ShieldCheck, Scale, UserPlus, BadgeCheck } from "lucide-react";
import { Kpi } from "../../../Component/RetailerComponents/Kpi";
import { useNavigate } from "react-router-dom";
import { ValueLoader } from "../../../Component/Common/ValueLoader";
import { AuthContext } from "../../../context/AuthContext";
import { useContext, useEffect, useState } from "react";


export default function KpiSection({ kpis, loading,balanceAmount, walletLoading, handlePayment, fromUserView, selectedUserRole, walletPermissionLoading, shouldShowWallet }) {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const userRole = Number(user?.role);
  
console.log("balanceAmount in kpisection: ", balanceAmount)
  const [showWalletPopup, setShowWalletPopup] = useState(false);
  const [walletAmount, setWalletAmount] = useState("");

  const progress =
    kpis?.revenue > 0
      ? Math.min(
          Math.round((kpis.paidAmount / kpis.revenue) * 100),
          100
        )
      : 0;

  
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 640);

useEffect(() => {
  const handleResize = () => {
    setIsMobileScreen(window.innerWidth < 640);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

const showMobileView = (userRole === 5 || userRole === 6 ) && isMobileScreen;
  return (
    <>
      {/* ================= DESKTOP VIEW ================= */}
      {!showMobileView && (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">

        {/* ==== YOUR ORIGINAL DESKTOP KPIs (UNCHANGED) ==== */}

        <Kpi
          label="Total Sales"
          value={loading ? <ValueLoader /> : `₹${(kpis.revenue / 1000).toFixed(1)}k`}
          sub={`Invoices: ${kpis.units1}`}
          icon={ReceiptIndianRupee}
          color="violet"
          onClick={() => navigate("/earnings")}
        />

        <Kpi
          label="Warranties"
          value={loading ? <ValueLoader /> : kpis.claims}
          sub="Total Warranties"
          icon={ShieldCheck}
          color="indigo"
          onClick={() => navigate("/retwarnty")}
        />

        <Kpi
          label="Pending Invoices"
          value={loading ? <ValueLoader /> : kpis.units}
          sub={`Uninvoiced: ₹${kpis.uninvoicedAmount}`}
          icon={FileSpreadsheet}
          color="rose"
          onClick={() =>
            navigate("/retinv", { state: { defaultTab: "uninvoiced" } })
          }
        />

       <Kpi
          label="Paid vs Payable"
          icon={Scale}
          color="blue"
          value={
            loading ? (
              <ValueLoader />
            ) : (
              <div className="font-semibold text-slate-800">
                ₹{kpis.paidAmount.toLocaleString()}
                <span className="mx-1 text-slate-400">/</span>
                ₹{kpis.payableAmount.toLocaleString()}
              </div>
            )
          }
          sub="Paid / Payable Amount"
        />

        {userRole !== 6 && (
          <Kpi
            label="Credit Notes"
            value={loading ? <ValueLoader /> : `₹${kpis.creditNotes.toLocaleString()}`}
            sub="Total value issued"
            icon={FileBarChart2}
            color="amber"
          />
        )}

        <Kpi
          label="Earnings"
          value={loading ? <ValueLoader /> : `₹${kpis.myEarnings.toLocaleString()}`}
          sub="Net earnings"
          icon={ReceiptIndianRupee}
          color="emerald"
          highlight
          onClick={() => navigate("/earnings")}
        />

        {(Number(user?.role) === 5 || Number(user?.role) === 6) && fromUserView === false && (
          <>
            <ShortcutCard
              onAddCustomer={() => navigate("/customer-create")}
            />

            
          </>
        )}
        {fromUserView === false &&
         (userRole !== 6 || (!walletPermissionLoading && shouldShowWallet)) && (
            <WalletCard
              balanceAmount={balanceAmount}
              walletLoading={walletLoading}
              openWalletPopup={() => setShowWalletPopup(true)}
              userRole={userRole}
            />
        )}

        {showWalletPopup && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm">

            <div className="w-[320px] rounded-2xl bg-white p-6 shadow-xl animate-fadeIn">

              <h2 className="text-lg font-semibold text-center mb-4">
                Add Wallet Balance
              </h2>

              {/* Amount Input */}
              <input
                type="number"
                placeholder="Enter Amount (₹)"
                value={walletAmount}
                onChange={(e) => setWalletAmount(e.target.value)}
                className="w-full border rounded-xl px-4 py-3 mb-4 focus:ring-2 focus:ring-blue-500 outline-none"
              />

              {/* Amount Badges */}
              <div className="flex gap-2 mb-5">
                {[1000, 3000, 5000].map((amt) => (
                  <button
                    key={amt}
                    onClick={() => setWalletAmount(String(amt))}
                    className={`flex-1 border rounded-lg py-2 text-sm font-semibold transition
                      ${
                        walletAmount == amt
                          ? "bg-blue-600 text-white border-blue-600"
                          : "hover:bg-blue-50"
                      }`}
                  >
                    ₹{amt}
                  </button>
                ))}
              </div>

              {/* Buttons */}
              <div className="flex gap-4">
                <button
                  onClick={() => setShowWalletPopup(false)}
                  className="flex-1 py-2 px-3 rounded-lg border text-gray-600"
                >
                  Cancel
                </button>
                <button
                  disabled={!walletAmount || Number(walletAmount) < 1000}
                  onClick={() =>
                    handlePayment(walletAmount, () => {
                      setShowWalletPopup(false); // ✅ CLOSE POPUP
                      setWalletAmount("");       // optional reset
                    })
                  }
                  className={`w-full py-3 rounded-xl font-semibold transition ${
                    Number(walletAmount) < 1000
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-400 hover:bg-blue-700 text-white"
                  }`}
                >
                  Add Balance
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      )}


      {/* ================= MOBILE VIEW ================= */}
      {showMobileView && (
      <div className="space-y-6">

        {/* ===== BIG GLASS CARD ===== */}
        <div className="glass-card p-6 relative overflow-hidden backdrop-blur-2xl">
          <div className="absolute -top-20 -right-20 w-40 h-40 bg-white/30 rounded-full blur-3xl opacity-40"></div>
          <p className="text-sm text-slate-600 font-medium">
            Total Sales
          </p>

          <div className="flex items-center justify-between mt-3">
            <div>
              <p className="text-3xl font-bold text-slate-900">
                ₹{kpis.revenue.toLocaleString()}
              </p>
              <p className="text-xs mt-1">
                <span className="text-green-600 font-semibold">
                  {kpis.units1}
                </span>

                <span className="text-slate-400 mx-1">/</span>

                <span className="text-red-500 font-semibold">
                  {kpis.units}
                </span>

                <span className="text-slate-500 ml-1">
                  Invoices
                </span>
              </p>
            </div>

            {/* Circle Progress */}
            {/* <div className="relative w-20 h-20">
              <svg className="w-20 h-20 -rotate-90">
                <circle
                  cx="40"
                  cy="40"
                  r="34"
                  stroke="#e5e7eb"
                  strokeWidth="6"
                  fill="transparent"
                />
                <circle
                  cx="40"
                  cy="40"
                  r="34"
                  stroke="#3b82f6"
                  strokeWidth="6"
                  fill="transparent"
                  strokeDasharray={214}
                  strokeDashoffset={214 - (214 * progress) / 100}
                  strokeLinecap="round"
                />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-slate-700">
                {progress}%
              </div>
            </div> */}

            <div
              onClick={() => navigate("/retwarnty")}
              className="glass-small-card"
            >
              <p className="text-xs text-slate-500">Warranties</p>
              <p className="text-xl font-bold text-slate-900 mt-1">
                {kpis.claims}
              </p>
            </div>


          </div>

          {/* MINI KPI ROW */}
          <div
            className={`grid gap-3 mt-6 ${
              userRole === 6 ? "grid-cols-2 justify-start" : "grid-cols-3"
            }`}
          >
            <div className="glass-small-card">
              <p className="text-xs text-slate-500">Pending</p>
              <p className="font-semibold text-slate-800 text-sm">
                ₹{kpis.payableAmount.toLocaleString()}
              </p>
            </div>

            <div className="glass-small-card">
              <p className="text-xs text-slate-500">Paid</p>
              <p className="font-semibold text-emerald-600 text-sm">
                ₹{kpis.paidAmount.toLocaleString()}
              </p>
            </div>

            {userRole !== 6 && (
              <div className="glass-small-card">
                <p className="text-xs text-slate-500">Credit</p>
                <p className="font-semibold text-amber-600 text-sm">
                  ₹{kpis.creditNotes.toLocaleString()}
                </p>
              </div>
            )}

            {/* <div
              onClick={() =>
                navigate("/retinv", {
                  state: { defaultTab: "uninvoiced" },
                })
              }
              className="glass-small-card"
            >
              <p className="text-xs text-slate-500">Pending Invoices</p>
              <p className="text-sm font-bold text-slate-900 mt-1">
                {kpis.units}
              </p>
            </div> */}
          </div>
        </div>


        {/* MY EARNINGS */}
        <div
          onClick={() => navigate("/earnings")}
          className="rounded-3xl p-5 bg-white/25 backdrop-blur-xl border border-white/40 shadow-lg flex justify-between items-center cursor-pointer"
        >
          <div>
            <p className="text-sm text-slate-600">
              My Earnings
            </p>
            <p className="text-2xl font-bold text-slate-900 mt-1">
              ₹{kpis.myEarnings.toLocaleString()}
            </p>
          </div>

          <div className="w-12 h-12 rounded-xl bg-emerald-500/20 flex items-center justify-center text-emerald-600">
            ₹
          </div>
        </div>

        {/* ADD WARRANTY */}
        {/* {Number(user?.role) === 5 && (
          <div
            onClick={() => navigate("/customer-create")}
            className="rounded-3xl p-5 bg-gradient-to-br from-blue-600/80 to-indigo-700/80 text-white cursor-pointer"
          >
            <p className="text-lg font-semibold">
              + Add Warranty
            </p>
            <p className="text-sm text-white/80 mt-1">
              Register new product warranty
            </p>
          </div>
        )} */}

        
      </div>
      )}
    </>
  );
}


function ShortcutCard({ onAddCustomer, balanceAmount, walletLoading, openWalletPopup, handlePayment  }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={onAddCustomer}
      className="group relative overflow-hidden 
      bg-gradient-to-br from-blue-700 to-blue-900 
      rounded-2xl border border-blue-600/30 
      shadow-md hover:shadow-xl 
      transition-all duration-300 
      p-4 flex flex-col gap-3 
      w-full"
    >
      {/* Hover Glow */}
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-300 bg-white/5" />

      {/* Top Section */}
      <div className="flex items-center gap-4 relative z-10">
        
        {/* Icon */}
        <div
          className="w-11 h-11 flex items-center justify-center 
          rounded-full bg-white/10 backdrop-blur-md 
          text-white 
          group-hover:scale-110 transition-transform duration-300"
        >
          <UserPlus className="w-5 h-5" />
        </div>

        {/* Text */}
        <div className="text-left">
          <h3 className="text-base font-semibold text-white tracking-wide">
            Add Warranty
          </h3>
          <p className="text-xs text-blue-200 ">
            Register new device warranty
          </p>
        </div>

      </div>

      <button
        onClick={onAddCustomer}
        className="text-xs bg-white text-blue-700 px-3 py-2 rounded-lg font-semibold hover:bg-emerald-50"
      >
        Add Warranty
      </button>

      {/* Wallet Section Bottom */}
      {/* {balanceAmount !== null && (
       <div
          className="relative z-10 flex items-center justify-between 
          px-3 py-2 
          rounded-xl 
          bg-white/10 backdrop-blur-md 
          border border-white/20"
        >
          <span
            onClick={(e) => {
              e.stopPropagation();
              navigate("/retailer-transactions");
            }}
            className="text-xs text-blue-100 font-medium cursor-pointer"
          >
            Wallet Balance
          </span>

          {walletLoading ? (
            <ValueLoader />
          ) : (
            <div className="flex items-center gap-2">
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/retailer-transactions");
                }}
                className="text-sm font-bold text-white cursor-pointer"
              >
                ₹{balanceAmount}
              </span>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  openWalletPopup();
                }}
                className="text-xs bg-white text-blue-700 px-2 py-1 rounded-md font-semibold hover:bg-blue-50"
              >
                Add Balance
              </button>
            </div>
          )}
        </div>
      )} */}
    </button>
    
  );
}

function WalletCard({ balanceAmount, walletLoading, openWalletPopup, userRole }) {
  const navigate = useNavigate();
  console.log("balanceAmount in walletcard: ", balanceAmount)

  return (
    <div
      onClick={() => navigate("/retailer-transactions")}
      className="relative overflow-hidden 
      bg-gradient-to-br from-emerald-600 to-teal-700
      rounded-2xl border border-emerald-500/30
      shadow-md hover:shadow-xl
      transition-all duration-300
      p-4 flex flex-col gap-3
      w-full text-white"
    >
      {/* Top Row */}
      <div className="flex items-center justify-between">

        <div>
          <p className="text-xs text-emerald-100">
            Wallet Balance
          </p>

          {walletLoading ? (
            <ValueLoader />
          ) : (
            <p
              
              className="text-xl font-bold cursor-pointer"
            >
              ₹{balanceAmount ? balanceAmount.toLocaleString() : "0"}
            </p>
          )}
        </div>

        <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
          💰
        </div>

      </div>

      {/* Add Balance Button */}
      {userRole === 5 && (
      <button
        onClick={(e) => {
          e.stopPropagation();
          openWalletPopup();
        }}
        className="text-xs bg-white text-emerald-700 px-3 py-2 rounded-lg font-semibold hover:bg-emerald-50"
      >
        Add Balance
      </button>
      )}
    </div>
  );
}

function ShortcutItem({ label, icon, color, onClick }) {
  const colorMap = {
    blue: "bg-blue-600 text-white hover:bg-blue-50",
    indigo: "bg-indigo-50 text-indigo-700 hover:bg-indigo-100",
    slate: "bg-slate-50 text-slate-700 hover:bg-slate-100",
    emerald: "bg-emerald-50 text-emerald-700 hover:bg-emerald-100",
  };

  return (
    <button
      onClick={onClick}
      className={`flex flex-col items-center justify-center gap-1 p-2 rounded-lg transition ${colorMap[color]}`}
    >
      {icon}
      <span className="text-md font-medium text-center leading-tight">
        {label}
      </span>
    </button>
  );
}

// ******************************************mobile view*********************************************************

// import { ReceiptIndianRupee, FileSpreadsheet, FileBarChart2, ShieldCheck, Scale, UserPlus, BadgeCheck } from "lucide-react";
// import { Kpi } from "../../../Component/RetailerComponents/Kpi";
// import { useNavigate } from "react-router-dom";
// import { ValueLoader } from "../../../Component/Common/ValueLoader";
// import { AuthContext } from "../../../context/AuthContext";
// import { useContext } from "react";

// export default function KpiSection({ kpis, loading }) {
//   const navigate = useNavigate();

//   const progress =
//     kpis.revenue > 0
//       ? Math.min(
//           Math.round((kpis.paidAmount / kpis.revenue) * 100),
//           100
//         )
//       : 0;

//   return (
//     <div className="space-y-6">

//       {/* ================= MAIN BIG CARD ================= */}
//       <div className="
//         relative rounded-3xl p-6
//         bg-white/30 backdrop-blur-2xl
//         border border-white/40
//         shadow-[0_10px_40px_rgba(0,0,0,0.08)]
//       ">

//         <p className="text-sm text-slate-600 font-medium">
//           Today’s Sales
//         </p>

//         <div className="flex items-center justify-between mt-3">

//           {/* Amount */}
//           <div>
//             <p className="text-3xl font-bold text-slate-900">
//               ₹{kpis.revenue.toLocaleString()}
//             </p>
//             <p className="text-xs text-slate-500 mt-1">
//               {kpis.units} Invoices
//             </p>
//           </div>

//           {/* Circle Progress */}
//           <div className="relative w-20 h-20">
//             <svg className="w-20 h-20 -rotate-90">
//               <circle
//                 cx="40"
//                 cy="40"
//                 r="34"
//                 stroke="#e5e7eb"
//                 strokeWidth="6"
//                 fill="transparent"
//               />
//               <circle
//                 cx="40"
//                 cy="40"
//                 r="34"
//                 stroke="#3b82f6"
//                 strokeWidth="6"
//                 fill="transparent"
//                 strokeDasharray={214}
//                 strokeDashoffset={214 - (214 * progress) / 100}
//                 strokeLinecap="round"
//               />
//             </svg>
//             <div className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-slate-700">
//               {progress}%
//             </div>
//           </div>
//         </div>

//         {/* MINI KPI ROW */}
//         <div className="grid grid-cols-3 gap-3 mt-6">

//           <div className="glass-small-card">
//             <p className="text-xs text-slate-500">Pending</p>
//             <p className="font-semibold text-slate-800 text-sm">
//               ₹{kpis.payableAmount.toLocaleString()}
//             </p>
//           </div>

//           <div className="glass-small-card">
//             <p className="text-xs text-slate-500">Paid</p>
//             <p className="font-semibold text-emerald-600 text-sm">
//               ₹{kpis.paidAmount.toLocaleString()}
//             </p>
//           </div>

//           <div className="glass-small-card">
//             <p className="text-xs text-slate-500">Credit</p>
//             <p className="font-semibold text-amber-600 text-sm">
//               ₹{kpis.creditNotes.toLocaleString()}
//             </p>
//           </div>

//         </div>
//       </div>

//       {/* ================= GRID KPIs (NOT REMOVED) ================= */}
//       <div className="grid grid-cols-2 gap-4">

//         <div
//           onClick={() => navigate("/retwarnty")}
//           className="glass-small-card"
//         >
//           <p className="text-xs text-slate-500">Warranties</p>
//           <p className="text-xl font-bold text-slate-900 mt-1">
//             {kpis.claims}
//           </p>
//         </div>

//         <div
//           onClick={() =>
//             navigate("/retinv", {
//               state: { defaultTab: "uninvoiced" },
//             })
//           }
//           className="glass-small-card"
//         >
//           <p className="text-xs text-slate-500">Pending Invoices</p>
//           <p className="text-xl font-bold text-slate-900 mt-1">
//             {kpis.units}
//           </p>
//         </div>

//       </div>

//       {/* ================= MY EARNINGS ================= */}
//       <div
//         onClick={() => navigate("/earnings")}
//         className="
//           rounded-3xl p-5
//           bg-white/25 backdrop-blur-xl
//           border border-white/40
//           shadow-[0_8px_32px_rgba(0,0,0,0.06)]
//           flex justify-between items-center
//           cursor-pointer
//         "
//       >
//         <div>
//           <p className="text-sm text-slate-600">
//             My Earnings
//           </p>
//           <p className="text-2xl font-bold text-slate-900 mt-1">
//             ₹{kpis.myEarnings.toLocaleString()}
//           </p>
//         </div>

//         <div className="w-12 h-12 rounded-xl bg-emerald-500/20 flex items-center justify-center text-emerald-600">
//           ₹
//         </div>
//       </div>

//       {/* ================= ADD WARRANTY (ROLE 5) ================= */}
//       <div
//         onClick={() => navigate("/customer-create")}
//         className="
//           rounded-3xl p-5
//           bg-gradient-to-br from-blue-600/80 to-indigo-700/80
//           backdrop-blur-xl
//           border border-white/20
//           shadow-lg
//           text-white
//           cursor-pointer
//         "
//       >
//         <p className="text-lg font-semibold">
//           + Add Warranty
//         </p>
//         <p className="text-sm text-white/80 mt-1">
//           Register new product warranty
//         </p>
//       </div>

//     </div>
//   );
// }

// function ShortcutCard({ onAddCustomer }) {
//   return (
//     <button
//       onClick={onAddCustomer}
//       className="group relative overflow-hidden 
//       bg-gradient-to-br from-blue-700 to-blue-900 
//       rounded-2xl border border-blue-600/30 
//       shadow-md hover:shadow-xl 
//       transition-all duration-300 
//       p-4 flex items-center gap-4 
//       w-full"
//     >
//       {/* Subtle Hover Glow */}
//       <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-300 bg-white/5" />

//       {/* Icon */}
//       <div className="relative z-10 w-14 h-14 flex items-center justify-center 
//         rounded-full bg-white/10 backdrop-blur-md 
//         text-white 
//         group-hover:scale-110 transition-transform duration-300"
//       >
//         <UserPlus className="w-6 h-6" />
//       </div>

//       {/* Text Content */}
//       <div className="relative z-10 text-left">
//         <h3 className="text-base font-semibold text-white tracking-wide">
//           Add Warranty
//         </h3>
//       </div>
//     </button>
//   );
// }


// function ShortcutItem({ label, icon, color, onClick }) {
//   const colorMap = {
//     blue: "bg-blue-600 text-white hover:bg-blue-50",
//     indigo: "bg-indigo-50 text-indigo-700 hover:bg-indigo-100",
//     slate: "bg-slate-50 text-slate-700 hover:bg-slate-100",
//     emerald: "bg-emerald-50 text-emerald-700 hover:bg-emerald-100",
//   };

//   return (
//     <button
//       onClick={onClick}
//       className={`flex flex-col items-center justify-center gap-1 p-2 rounded-lg transition ${colorMap[color]}`}
//     >
//       {icon}
//       <span className="text-md font-medium text-center leading-tight">
//         {label}
//       </span>
//     </button>
//   );
// }


// *************************************************desktop view*********************************************************8

// import { ReceiptIndianRupee, FileSpreadsheet, FileBarChart2, ShieldCheck, Scale, UserPlus, BadgeCheck } from "lucide-react";
// import { Kpi } from "../../../Component/RetailerComponents/Kpi";
// import { useNavigate } from "react-router-dom";
// import { ValueLoader } from "../../../Component/Common/ValueLoader";
// import { AuthContext } from "../../../context/AuthContext";
// import { useContext } from "react";

// export default function KpiSection({ kpis, loading  }) {
//   const navigate = useNavigate();
//   const { user } = useContext(AuthContext);
//   return (
//     <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//       <Kpi
//         label="Total Sales"
//         value={loading ? <ValueLoader /> : `₹${(kpis.revenue / 1000).toFixed(1)}k`}
//         sub={`Invoices: ${kpis.units}`}
//         icon={ReceiptIndianRupee}
//         color="violet"
//         onClick={() => navigate("/earnings")}
//       />

//       <Kpi
//         label="Warranties"
//         value={loading ? <ValueLoader /> : kpis.claims}
//         sub="Total Warranties"
//         icon={ShieldCheck}
//         color="indigo"
//         onClick={() => navigate("/retwarnty")}
//       />   

//       <Kpi
//           label="Pending Invoices"
//           value={loading ? <ValueLoader /> : kpis.units}
//           sub={`Uninvoiced: ₹${(kpis.uninvoicedAmount)}`}
//           icon={FileSpreadsheet}
//           color="rose"
//           onClick={() =>
//             navigate("/retinv", {
//               state: { defaultTab: "uninvoiced" },
//             })
//           }
//         />

//         <Kpi
//           label="Payable Amount"
//           value={loading ? <ValueLoader /> : `₹${kpis.payableAmount.toLocaleString()}` || 0}
//           sub="Pending"
//           icon={Scale}
//           color="blue"
//           onClick={() =>
//             navigate("/retinv", {
//               state: { defaultTab: "uninvoiced" },
//             })
//           }

//         />


//         <Kpi
//           label="Paid Amount"
//           value={loading ? <ValueLoader /> : `₹${kpis.paidAmount.toLocaleString()}`}
//           sub="Received till now"
//           icon={BadgeCheck}
//           color="emerald"
//           onClick={() =>
//             navigate("/retinv", {
//               state: { defaultTab: "invoiced" },
//             })
//           }
//         />

//       <Kpi
//         label="Credit Notes"
//         value={loading ? <ValueLoader /> : `₹${kpis.creditNotes.toLocaleString()}`}
//         sub="Total value issued"
//         icon={FileBarChart2}
//         color="amber"
//         onClick={() =>
//           navigate("/retinv", {
//             state: { defaultTab: "creditNotes" },
//           })
//         }
//       />

//       <Kpi
//         label="My Earnings"
//         value={loading ? <ValueLoader /> : `₹${kpis.myEarnings.toLocaleString()}`}
//         sub="Net earnings"
//         icon={ReceiptIndianRupee}
//         color="emerald"
//         highlight={true}   // 👈 add this
//         onClick={() => navigate("/earnings")}
//       />

      

//       {user.role === 5 && (
//         <ShortcutCard
//             onAddCustomer={() => navigate("/customer-create")}
//             onViewWarranties={() => navigate("/retwarnty")}
//             onViewCustomers={() => navigate("/customers")}
//             onAddUser={() => navigate("/add-entity/retailer-user")}
//           />
//       )}
//     </div>
//   );
// }

// function ShortcutCard({ onAddCustomer }) {
//   return (
//     <button
//       onClick={onAddCustomer}
//       className="group relative overflow-hidden 
//       bg-gradient-to-br from-blue-700 to-blue-900 
//       rounded-2xl border border-blue-600/30 
//       shadow-md hover:shadow-xl 
//       transition-all duration-300 
//       p-4 flex items-center gap-4 
//       w-full"
//     >
//       {/* Subtle Hover Glow */}
//       <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-300 bg-white/5" />

//       {/* Icon */}
//       <div className="relative z-10 w-14 h-14 flex items-center justify-center 
//         rounded-full bg-white/10 backdrop-blur-md 
//         text-white 
//         group-hover:scale-110 transition-transform duration-300"
//       >
//         <UserPlus className="w-6 h-6" />
//       </div>

//       {/* Text Content */}
//       <div className="relative z-10 text-left">
//         <h3 className="text-base font-semibold text-white tracking-wide">
//           Add Warranty
//         </h3>
//       </div>
//     </button>
//   );
// }


// function ShortcutItem({ label, icon, color, onClick }) {
//   const colorMap = {
//     blue: "bg-blue-600 text-white hover:bg-blue-50",
//     indigo: "bg-indigo-50 text-indigo-700 hover:bg-indigo-100",
//     slate: "bg-slate-50 text-slate-700 hover:bg-slate-100",
//     emerald: "bg-emerald-50 text-emerald-700 hover:bg-emerald-100",
//   };

//   return (
//     <button
//       onClick={onClick}
//       className={`flex flex-col items-center justify-center gap-1 p-2 rounded-lg transition ${colorMap[color]}`}
//     >
//       {icon}
//       <span className="text-md font-medium text-center leading-tight">
//         {label}
//       </span>
//     </button>
//   );
// }



// import { ReceiptIndianRupee, FileSpreadsheet, FileBarChart2, ShieldCheck, Scale, UserPlus } from "lucide-react";
// import { Kpi } from "../../../Component/RetailerComponents/Kpi";
// import { useNavigate } from "react-router-dom";
// import { ValueLoader } from "../../../Component/Common/ValueLoader";
// import { AuthContext } from "../../../context/AuthContext";
// import { useContext } from "react";

// export default function KpiSection({ kpis, loading  }) {
//   const navigate = useNavigate();
//   const { user } = useContext(AuthContext);
//   return (
//     <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//       <Kpi
//         label="Total Sales"
//         value={loading ? <ValueLoader /> : `₹${(kpis.revenue / 1000).toFixed(1)}k`}
//         sub={`Invoices: ${kpis.units}`}
//         icon={ReceiptIndianRupee}
//         color="violet"
//         onClick={() => navigate("/earnings")}
//       />

//        <Kpi
//           label="Pending Invoices"
//           value={loading ? <ValueLoader /> : kpis.units}
//           sub={`Uninvoiced: ₹${(kpis.uninvoicedAmount)}`}
//           icon={FileSpreadsheet}
//           color="rose"
//           onClick={() =>
//             navigate("/retinv", {
//               state: { defaultTab: "uninvoiced" },
//             })
//           }
//         />

//       <Kpi
//         label="Credit Notes"
//         value={loading ? <ValueLoader /> : `₹${kpis.creditNotes.toLocaleString()}`}
//         sub="Total value issued"
//         icon={FileBarChart2}
//         color="amber"
//         onClick={() =>
//           navigate("/retinv", {
//             state: { defaultTab: "creditNotes" },
//           })
//         }
//       />

//       <Kpi
//         label="Warranty Filed"
//         value={loading ? <ValueLoader /> : kpis.claims}
//         sub="Total Warranties"
//         icon={ShieldCheck}
//         color="indigo"
//         onClick={() => navigate("/retwarnty")}
//       />

//       <Kpi
//           label="Payable Amount"
//           value={loading ? <ValueLoader /> : `₹${kpis.payableAmount.toLocaleString()}` || 0}
//           sub="Pending"
//           icon={Scale}
//           color="blue"
//           onClick={() =>
//             navigate("/retinv", {
//               state: { defaultTab: "uninvoiced" },
//             })
//           }

//         />

//       <Kpi
//         label="Paid Amount"
//         value={loading ? <ValueLoader /> : `₹${kpis.paidAmount.toLocaleString()}`}
//         sub="Received till now"
//         icon={ReceiptIndianRupee}
//         color="emerald"
//         onClick={() =>
//           navigate("/retinv", {
//             state: { defaultTab: "invoiced" },
//           })
//         }
//       />

//       <Kpi
//         label="My Earnings"
//         value={loading ? <ValueLoader /> : `₹${kpis.myEarnings.toLocaleString()}`}
//         sub="Net earnings"
//         icon={ReceiptIndianRupee}
//         color="stone"
//         onClick={() => navigate("/earnings")}
//       />

//       {user.role === 5 && (
//         <ShortcutCard
//             onAddCustomer={() => navigate("/customer-create")}
//             onViewWarranties={() => navigate("/retwarnty")}
//             onViewCustomers={() => navigate("/customers")}
//             onAddUser={() => navigate("/add-entity/retailer-user")}
//           />
//       )}
//     </div>
//   );
// }

// function ShortcutCard({
//   onAddCustomer,
//   onViewWarranties,
//   onViewCustomers,
//   onAddUser,
// }) {
//   return (
//     <div className="bg-white rounded-xl border border-slate-100 shadow-lg p-2 h-full">
//       <p className="text-[12px] font-bold uppercase tracking-wide text-slate-900 mb-1">
//         Quick Shortcuts
//       </p>

//       <div className="grid grid-cols-1 gap-2">

//         <ShortcutItem
//           label="Add Warranty"
//           icon={<UserPlus className="w-4 h-4" />}
//           color="blue"
//           onClick={onAddCustomer}
//         />

//         {/* <ShortcutItem
//           label="Warranties"
//           icon={<ShieldCheck className="w-4 h-4" />}
//           color="indigo"
//           onClick={onViewWarranties}
//         />

//         <ShortcutItem
//           label="Customers"
//           icon={<Users className="w-4 h-4" />}
//           color="slate"
//           onClick={onViewCustomers}
//         /> */}

//         {/* <ShortcutItem
//           label="Add User"
//           icon={<PlusCircle className="w-4 h-4" />}
//           color="emerald"
//           onClick={onAddUser}
//         /> */}

//       </div>
//     </div>
//   );
// }

// function ShortcutItem({ label, icon, color, onClick }) {
//   const colorMap = {
//     blue: "bg-blue-100 text-blue-700 hover:bg-blue-50",
//     indigo: "bg-indigo-50 text-indigo-700 hover:bg-indigo-100",
//     slate: "bg-slate-50 text-slate-700 hover:bg-slate-100",
//     emerald: "bg-emerald-50 text-emerald-700 hover:bg-emerald-100",
//   };

//   return (
//     <button
//       onClick={onClick}
//       className={`flex flex-col items-center justify-center gap-1 p-2 rounded-lg transition ${colorMap[color]}`}
//     >
//       {icon}
//       <span className="text-[13px] font-medium text-center leading-tight">
//         {label}
//       </span>
//     </button>
//   );
// }


// import { ReceiptIndianRupee, FileSpreadsheet, FileBarChart2, ShieldCheck, Scale, UserPlus } from "lucide-react";
// import { Kpi } from "../../../Component/RetailerComponents/Kpi";
// import { useNavigate } from "react-router-dom";
// import { ValueLoader } from "../../../Component/Common/ValueLoader";

// export default function KpiSection({ kpis, loading  }) {
//   const navigate = useNavigate();
//   return (
//     <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//       <Kpi
//         label="Total Sales"
//         value={loading ? <ValueLoader /> : `₹${(kpis.revenue / 1000).toFixed(1)}k`}
//         sub={`Invoices: ${kpis.units}`}
//         icon={ReceiptIndianRupee}
//         color="violet"

//       />

//        <Kpi
//           label="Pending Invoices"
//           value={loading ? <ValueLoader /> : kpis.units}
//           sub={`Uninvoiced: ₹${(kpis.uninvoicedAmount)}`}
//           icon={FileSpreadsheet}
//           color="rose"
//         />

//       <Kpi
//         label="Credit Notes"
//         value={loading ? <ValueLoader /> : `₹${kpis.creditNotes.toLocaleString()}`}
//         sub="Total value issued"
//         icon={FileBarChart2}
//         color="amber"
//       />

//       <Kpi
//         label="Warranty Filed"
//         value={loading ? <ValueLoader /> : kpis.claims}
//         sub="Total Warranties"
//         icon={ShieldCheck}
//         color="indigo"
//       />

//       <Kpi
//           label="Payable Amount"
//           value={loading ? <ValueLoader /> : `₹${kpis.payableAmount.toLocaleString()}` || 0}
//           sub="Pending"
//           icon={Scale}
//           color="blue"
//         />

//       <Kpi
//         label="Paid Amount"
//         value={loading ? <ValueLoader /> : `₹${kpis.paidAmount.toLocaleString()}`}
//         sub="Received till now"
//         icon={ReceiptIndianRupee}
//         color="emerald"
//       />

//       <Kpi
//         label="My Earnings"
//         value={loading ? <ValueLoader /> : `₹${kpis.myEarnings.toLocaleString()}`}
//         sub="Net earnings"
//         icon={ReceiptIndianRupee}
//         color="stone"
//       />

//       <ShortcutCard
//             onAddCustomer={() => navigate("/customer-create")}
//             onViewWarranties={() => navigate("/retwarnty")}
//             onViewCustomers={() => navigate("/customers")}
//             onAddUser={() => navigate("/add-entity/retailer-user")}
//           />
//     </div>
//   );
// }

// function ShortcutCard({
//   onAddCustomer,
//   onViewWarranties,
//   onViewCustomers,
//   onAddUser,
// }) {
//   return (
//     <div className="bg-white rounded-xl border border-slate-100 shadow-lg p-2 h-full">
//       <p className="text-[12px] font-bold uppercase tracking-wide text-slate-900 mb-1">
//         Quick Shortcuts
//       </p>

//       <div className="grid grid-cols-1 gap-2">

//         <ShortcutItem
//           label="Add Warranty"
//           icon={<UserPlus className="w-4 h-4" />}
//           color="blue"
//           onClick={onAddCustomer}
//         />

//         {/* <ShortcutItem
//           label="Warranties"
//           icon={<ShieldCheck className="w-4 h-4" />}
//           color="indigo"
//           onClick={onViewWarranties}
//         />

//         <ShortcutItem
//           label="Customers"
//           icon={<Users className="w-4 h-4" />}
//           color="slate"
//           onClick={onViewCustomers}
//         /> */}

//         {/* <ShortcutItem
//           label="Add User"
//           icon={<PlusCircle className="w-4 h-4" />}
//           color="emerald"
//           onClick={onAddUser}
//         /> */}

//       </div>
//     </div>
//   );
// }

// function ShortcutItem({ label, icon, color, onClick }) {
//   const colorMap = {
//     blue: "bg-blue-100 text-blue-700 hover:bg-blue-50",
//     indigo: "bg-indigo-50 text-indigo-700 hover:bg-indigo-100",
//     slate: "bg-slate-50 text-slate-700 hover:bg-slate-100",
//     emerald: "bg-emerald-50 text-emerald-700 hover:bg-emerald-100",
//   };

//   return (
//     <button
//       onClick={onClick}
//       className={`flex flex-col items-center justify-center gap-1 p-2 rounded-lg transition ${colorMap[color]}`}
//     >
//       {icon}
//       <span className="text-[13px] font-medium text-center leading-tight">
//         {label}
//       </span>
//     </button>
//   );
// }




// import { BadgeIndianRupee, Boxes, FileText, Percent, Users } from "lucide-react";
// import { Kpi } from "../../../Component/RetailerComponents/Kpi";
// import { money, pct } from "../../../utils/helpers";

// export default function KpiSection({ kpis }) {
//   return (
//     <div className="grid grid-cols-2 gap-3 md:grid-cols-5">
//       <Kpi icon={BadgeIndianRupee} label="Revenue" value={money(kpis.revenue)} sub="Filtered total" />
//       <Kpi icon={Boxes} label="Units Sold" value={kpis.units} sub="Total units" />
//       <Kpi icon={FileText} label="Credit Notes" value={money(kpis.creditNotes)} sub="Total CN amount" />
//       <Kpi icon={Percent} label="CN Ratio" value={pct(kpis.creditRatio)} sub="CN / Revenue" />
//       <Kpi icon={Users} label="Claims" value={kpis.claims} sub="Total claims" />
//     </div>
//   );
// }
